import React from "react"
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react"
import { DatePicker, Flex, Input, Select, Typography, Checkbox } from "antd"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import { MaskedInput } from "antd-mask-input"
import { paymentsAction } from "src/store/Slices/Administrator/PaymentsSlice"
import { getUsers, getClubs, getTrainers } from "src/store/Slices/DropDownSlice"
import {
  addClent,
  editClent,
  getClientsList,
  getUserInfo,
} from "src/store/Slices/ClientsSlice"
import dayjs from "dayjs"
import { use } from "react"

const AddEditClientModal = ({
  visible,
  setVisible,
  clientInfo,
  setPage,
  setPageSize,
  addEditPayload,
}) => {
  const dispatch = useDispatch()
  const dateFormatList = ["DD.MM.YYYY"]

  const [phoneNumber, setPhoneNumber] = useState("")
  const [email, setEmail] = useState("")
  const [surname, setSurname] = useState("")
  const [name, setName] = useState("")
  const [patronymic, setPatronymic] = useState("")
  const [dateOfBirth, setDateOfBirth] = useState(null)
  const [clubId, setClubId] = useState()
  const [isEmploy, setIsEmploy] = useState(false)
  const [employId, setEmployId] = useState()

  const clubs = useSelector((state) => state.DropDownSlice.clubs)
  const trainersList = useSelector((state) => state.DropDownSlice.trainersList)

  useEffect(() => {
    setPhoneNumber()
    setEmail()
    setSurname()
    setName()
    setPatronymic()
    setDateOfBirth(null)
    setClubId()
    setIsEmploy(false)
    setEmployId()
  }, [visible.flag])

  useEffect(() => {
    if (visible.flag === "edit") {
      setPhoneNumber(clientInfo?.phoneNumber)
      setEmail(clientInfo?.eMail)
      setSurname(clientInfo?.clientF)
      setName(clientInfo?.clientI)
      setPatronymic(clientInfo?.clientO)
      setDateOfBirth(clientInfo?.birthday)
      setClubId(
        clubs?.data?.value?.find((el) => el.label === clientInfo?.club)?.value
      )
      setIsEmploy(clientInfo?.isEmploy === "Да" ? true : false)
      setEmployId(clientInfo?.employId)
    }
  }, [visible, clientInfo, clubs])

  useEffect(() => {
    if (visible.flag === "edit") {
      dispatch(getClubs())
      dispatch(getTrainers())
    }
  }, [visible])

  const onClickSubmit = () => {
    if (visible.flag === "add") {
      dispatch(
        addClent({
          phoneNumber: phoneNumber,
          eMail: email,
          clientF: surname,
          clientI: name,
          clientO: patronymic,
          birthday: dateOfBirth
            ? dayjs(dateOfBirth, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss")
            : null,
          clubId: clubId,
          isEmploy: isEmploy,
          employId: employId,
        })
      ).then(() => {
        dispatch(getClientsList(addEditPayload))
        setVisible({ open: false, flag: "" })
        setPage(1)
        setPageSize(20)
      })
    } else {
      dispatch(
        editClent({
          id: clientInfo.id,
          // Проверка, чтобы не отправляли один и тот же номер, нужно так бэку
          phoneNumber:
            clientInfo.phoneNumber !== phoneNumber ? phoneNumber : undefined,
          eMail: email,
          clientF: surname,
          clientI: name,
          clientO: patronymic,
          birthday: dateOfBirth
            ? dayjs(dateOfBirth, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss")
            : null,
          clubId: clubId,
          isEmploy: isEmploy,
          employId: employId,
        })
      ).then(() => {
        dispatch(getClientsList(addEditPayload))
        setVisible({ open: false, flag: "" })
        setPage(1)
        setPageSize(20)
      })
    }
  }
  useEffect(() => {
    console.log("isEmploy", isEmploy)
  })
  return (
    <CModal
      alignment='center'
      visible={visible.open}
      aria-labelledby='VerticallyCenteredExample'
      onClose={() => {
        setVisible({ open: false, flag: "" })
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id='VerticallyCenteredExample'>
          {visible.flag === "add"
            ? "Добавить клиента"
            : "Редактировать клиента"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16}>
          <div>
            <Typography.Title level={5}>Телефон</Typography.Title>
            <MaskedInput
              className='custom-input'
              mask='+{0} (000) 000-00-00'
              value={phoneNumber}
              onChange={(e) => {
                setPhoneNumber(e.target.value)
              }}
            />
          </div>

          <div>
            <Typography.Title level={5}>Почта</Typography.Title>
            <Input
              defaultValue=''
              value={email}
              onChange={(e) => {
                setEmail(e.currentTarget.value)
              }}
            />
          </div>

          <div>
            <Typography.Title level={5}>Фамилия</Typography.Title>
            <Input
              defaultValue=''
              value={surname}
              onChange={(e) => {
                setSurname(e.currentTarget.value)
              }}
            />
          </div>

          <div>
            <Typography.Title level={5}>Имя</Typography.Title>
            <Input
              defaultValue=''
              value={name}
              onChange={(e) => {
                setName(e.currentTarget.value)
              }}
            />
          </div>

          <div>
            <Typography.Title level={5}>Отчество</Typography.Title>
            <Input
              defaultValue=''
              value={patronymic}
              onChange={(e) => {
                setPatronymic(e.currentTarget.value)
              }}
            />
          </div>

          <div>
            <Typography.Title level={5}>Дата рождения</Typography.Title>
            <DatePicker
              onChange={(date, dateString) => {
                setDateOfBirth(dateString)
              }}
              style={{ width: "100%" }}
              format={"DD.MM.YYYY"}
              placement={"topRight"}
              defaultValue={dateOfBirth && dayjs(dateOfBirth, dateFormatList)}
            />
          </div>
          <div>
            <Typography.Title level={5}>Клуб</Typography.Title>
            <Select
              style={{ width: "100%" }}
              placeholder='Выбрать'
              onClick={() => {
                visible.flag === "add" && dispatch(getClubs())
              }}
              value={clubId}
              onChange={(e) => {
                setClubId(e)
              }}
              options={clubs?.data?.value}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <Checkbox
              checked={isEmploy === true}
              onChange={(e) => {
                setIsEmploy(e.target.checked ? true : false)
              }}
            />
            <Typography.Title level={5} style={{ margin: 0 }}>
              Является сотрудником
            </Typography.Title>
          </div>

          {isEmploy === true && (
            <div>
              <Typography.Title level={5}>
                Сотрудник: {clientInfo?.employFio}
              </Typography.Title>
              <Select
                placeholder='Выберите сотрудника'
                value={employId}
                onChange={(value) => {
                  setEmployId(value)
                }}
                options={trainersList?.data?.value}
                style={{ width: "100%" }}
                optionLabelProp='label'
              />
            </div>
          )}

        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setVisible({ open: false, flag: "" })
          }}
          className='text-light'
          color='secondary'
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickSubmit} className='text-light'>
          {visible.flag === "add" ? "Добавить" : "Редактировать"}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default AddEditClientModal
